<template>
  <div class="followup-reply-wrap">
    <div
      v-if="item && item.id"
      class="add-followup-reply"
    >
      <div class="followup-item">
        <!-- 回访记录详情 -->
        <div class="followup-detail">
          <div class="top clearfix">
            <span class="time">{{ moment(item.uptime * 1000).format(dateFormat) }}</span>
            <span class="name">{{ item.truename }}</span>
            <!-- 回复 -->
            <a
              class="fr reply-btn btn-text"
              @click="handleReply1(item)"
            >{{ $t('message["449"]') }}</a>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
        <!-- 回访记录上传图片列表 -->
        <a
          v-for="(file, i) in item.pics"
          :key="i"
          class="file"
          @click="handleclickGallery(item.pics, i)"
        ><i class="iconfont iconpic" /> {{ file.file_name }}</a>
      </div>
      <!-- 回访记录回复列表 -->
      <div
        class="replys-list"
        :class="{show: item.showReply}"
      >
        <ul v-if="item.replys">
          <li
            v-for="(reply, i) in item.replys"
            :id="`reply_${reply.id}`"
            :key="reply.id"
          >
            <div
              class="reply-top clearfix"
            >
              {{ moment(reply.addtime * 1000).format(dateFormat) }} {{ reply.truename }}
              <!-- 删除回访回复按钮 -->
              <a
                v-if="permissionInfo.is_del_followups"
                class="fr del-btn btn-text"
                @click="handleDeleteReply(reply.id, item.id)"
              >{{ $t('message["962"]') }}</a>
            </div>
            <div class="reply-content">
              @{{ reply.rtruename }}:{{ reply.content }}
            </div>
            <div
              class="reply-btn fs-blue"
              @click="handleReply2(reply, i)"
            >
              {{ $t('message["449"]') }}
            </div>
          </li>
        </ul>
      </div>

      <div class="add-box clearfix">
        <div
          class="input-wrap clearfix"
          @click="replyFocus"
        >
          <span
            ref="truename"
            class="truename"
          >@{{ currItem.truename }}:</span>
          <a-input
            ref="addReply"
            v-model="currItem.newReply"
            type="text"
            :style="{'padding-left': currItem.trueNameWidth + 'px'}"
            @blur="handleBlur"
          />
        </div>
        <a-button
          type="primary"
          :disabled="!currItem.newReply"
          @click="handleNewReply(currItem)"
        >
          {{ $t('message["449"]') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import { inquiryReplyFollowup } from '@/services/inqueryServices'

export default {
  data () {
    return {
      dateFormat: 'YYYY-MM-DD HH:mm',
      item: {},
      currItem: {},
      replytype: 1
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'followup'
    ]),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    followupid () {
      return this.$route.query.followupid
    }
  },
  async created () {
    await this.getFollowupList()

    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        let $app = document.getElementById('app')
        $app.style.height = this.$getPageSize().windowHeight + 'px'
      })
    })
  },
  methods: {
    moment,
    ...mapActions('inquery/detailData', [
      'fetchFollowupList',
      'inquiryDelFollowupReply'
    ]),
    async getFollowupList (newFollowupid) {
      let followupId = newFollowupid || this.followupid
      const chain = await this.fetchFollowupList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onSuccess(res => {
          if (this.followup.list && this.followup.list.length) {
            for (let index in this.followup.list) {
              let item = this.followup.list[index]
              if (parseInt(item.id) === parseInt(followupId)) {
                this.item = item
                this.currItem = item
                this.replytype = 1
                this.$set(item, 'showReply', true)
                this.setShowReplyTrueNameWidth(item, index)
                if (item.replys && item.replys.length === 0) {
                  setTimeout(() => {
                    this.replyFocus()
                  }, 300)
                }
              }
            }
            if (this.replyid) {
              let id = 'reply_' + this.replyid
              let $currReply = document.getElementById(id)
              setTimeout(() => {
                $currReply && $currReply.scrollIntoView(false)
              }, 30)
            }
          }
        })
        .fetch()
    },
    handleReply1 (item) {
      this.currItem = item
      this.replytype = 1
      this.setShowReplyTrueNameWidth(item)
      this.replyFocus()
    },
    handleReply2 (reply) {
      this.currItem = reply
      this.replytype = 2
      this.setShowReplyTrueNameWidth(reply)
      this.replyFocus()
    },
    setShowReplyTrueNameWidth (item) {
      setTimeout(() => {
        let trueNameWidth = this.$refs.truename && this.$refs.truename && this.$refs.truename.offsetWidth
        this.$set(item, 'trueNameWidth', trueNameWidth + 8)
      }, 30)
    },
    replyFocus () {
      this.$refs.addReply && this.$refs.addReply.focus()

      let $app = document.getElementById('app')
      $app.style.height = this.$getPageSize().windowHeight + 'px'
    },
    handleNewReply (item) {
      const obj = {
        replytype: this.replytype,
        content: item.newReply
      }
      if (this.replytype === 1) {
        obj.followupid = item.id
        obj.replyid = ''
      } else if (this.replytype === 2) {
        obj.followupid = item.followupid
        obj.replyid = item.id
      }
      this.confirmReply(obj)
      item.newReply = ''
    },

    async confirmReply ({ followupid, replyid, replytype, content }) {
      let params = {
        inquiryid: this.inquiryId,
        followupid,
        replytype, // 1回复回访记录 2回复回访记录评论
        content
      }
      if (replytype === 2) {
        params.replyid = replyid
      }
      let chain = await inquiryReplyFollowup()
      chain
        .params(params)
        .onNetSuccess(res => {
          this.getFollowupList(followupid)
        })
        .fetch()
    },
    handleBlur () {
      /* window.scrollTo({
        top: window.pageYOffset,
        behavior: 'smooth'
      }) */
    },
    handleDeleteReply (replyid) {
      let content = this.$t('message["1887"]') // 一旦删除，无法恢复，|是否继续？
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: this.$t('message["1889"]'), // '将删除该条回复'
        content: content,
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: async () => {
          const chain = await this.inquiryDelFollowupReply({
            inquiryid: this.inquiryId,
            id: replyid
          })
          chain
            .onSuccess(res => {
              this.getFollowupList()
            })
        }
      }).show()
    },
    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.followup-reply-wrap {
  padding-bottom: 48px;
}
.add-followup-reply{
  position: relative;
  padding-bottom: 4px;
  background-color: #fff;
  .followup-item {
    margin-top: 12px;
    padding: 16px 12px;
    background-color: #fff;

    .top {
      margin-bottom: 12px;
      font-size: 16px;
    }
    .time {
      margin-right: 8px;
    }
    .name {
      width: 56px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 8px;
    }
    .del-btn {
      float: right;
      color: $blue;
      font-size: 16px;
    }
    .content {
      line-height: 24px;
      color: #333;
      font-size: 16px;
      word-break: break-all;
    }

    a.file {
      display: block;
      margin: 10px 0;
      line-height: 24px;
      /* text-overflow: ellipsis;
      overflow: hidden; */
      word-break: break-all;
      &:last-child {
        margin-bottom: 0;
      }
      .iconpic {
        color: #dbdbdb;
      }
    }
  }
  .replys-list {
    display: none;
    margin: 0 4px;
    padding: 0 24px;
    background-color: #f5f5f5;
    border-radius: 2px;
    &.show {
      display: block;
    }
    li {
      padding: 12px 0 16px;
      border-bottom: solid 1px #dbdbdb;
      &:last-child {
        border: none;
      }
      .reply-top {
        margin-bottom: 12px;
      }
    }
  }
  .operate-btns {
    height: 32px;
    line-height: 32px;
    margin-top: 12px;
    text-align: right;
    color: #d6d6d6;
    .iconfont {
      margin-right: 5px;
    }
  }
  .reply-btn {
    text-align: right;
  }
  .add-box {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    height:48px;
    padding: 8px;
    border-top: solid 1px #dbdbdb;
    background-color: #fff;
    overflow: hidden;
    .input-wrap {
      width:295px;
      height:32px;
      margin-right: 8px;
      background:rgba(248,248,248,1);
      border-radius:1px;
      border:1px solid rgba(228,228,228,1);
      input {
        height: 100%;
        border: none;
        background-color: none;
      }
    }
    .truename {
      position: absolute;
      left: 0;
      z-index: 2;
      color:#b2b2b2;
      height:32px;
      line-height: 32px;
      margin-left: 12px;
    }
    .ant-btn {
      &.ant-btn[disabled] {
        color: #fff;
        background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
        box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
        border-radius:4px;
        border:1px solid rgba(80,119,170,1);
        opacity: 0.8;
      }
    }
  }
}
</style>
